import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  return (
    <footer className="footer" style={{ backgroundColor: '#000000' }}>
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="footercontact">
            <div className="textwidget">
              <h2 className="text-xl font-bold text-white mb-4">
                <strong>Get in Touch</strong>
              </h2>
              <p className="text-gray-300">
                <a href="mailto:sales@lloydjames.com" className="hover:text-white transition-colors">sales@lloydjames.com</a><br />
                <a href="tel:0800 288 9949" className="hover:text-white transition-colors">0800 288 9949</a>
              </p>
            </div>
          </div>
          
          <div className="footercontact">
            <div className="textwidget">
              <h2 className="text-xl font-bold text-white mb-4">
                <strong>Our Headquarters</strong>
              </h2>
              <p className="text-gray-300">
                Wolverhampton Office<br />
                2nd Floor<br />
                84 Salop Street<br />
                Wolverhampton<br />
                WV3 0SR
              </p>
            </div>
          </div>
          
          <div className="dmalogo">
            <div className="textwidget"></div>
          </div>
        </div>
      </div>
      
      <div className="container mx-auto px-4">
        <div className="btmfooter border-t border-pink-800 pt-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <p className="text-white font-semibold mb-4">Useful Links</p>
              <div className="menu-footer-container">
                <ul className="menu usefullinks space-y-0 md:space-y-2 mobile-footer-links">
                  <li>
                    <a target="_blank" href="/Dc/lloyd-james-media-privacy-policy.pdf" className="text-gray-300 hover:text-white transition-colors">Privacy Policy</a>
                  </li>
                  <li>
                    <a target="_blank" href="/Dc/lloyd-james-media-privacy-policy.pdf" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">Cookies Policy</a>
                  </li>
                  <li>
                    <a target="_blank" href="/Dc/LJM-Terms-and-Conditions-01032024.pdf" className="text-gray-300 hover:text-white transition-colors">T&C</a>
                  </li>
                  <li>
                    <a target="_blank" href="/Dc/LJM_Terms_and_Conditions_of_Inserts_27102025.pdf" className="text-gray-300 hover:text-white transition-colors">T&C for Inserts</a>
                  </li>
                  <li>
                    <a target="_blank" href="/Dc/LJ-Data-Consultancy-Brokering-Terms-and-Conditions-27102025.pdf" className="text-gray-300 hover:text-white transition-colors">T&C for brokering</a>
                  </li>
                  <li>
                    <Link to="/contact" onClick={handleScrollToTop} className="text-gray-300 hover:text-white transition-colors">Contact Us</Link>
                  </li>
                  <li>
                    <Link to="/unsubscribe" onClick={handleScrollToTop} className="text-gray-300 hover:text-white transition-colors">Unsubscribe</Link>
                  </li>
                  <li>
                    <Link to="/news" onClick={handleScrollToTop} className="text-gray-300 hover:text-white transition-colors">News</Link>
                  </li>
                  <li>
                    <Link to="/careers" onClick={handleScrollToTop} className="text-gray-300 hover:text-white transition-colors">Careers</Link>
                  </li>
                </ul>
              </div>
            </div>
            
            <div>
              <div className="textwidget">
                <p className="text-gray-300 text-sm leading-relaxed">
                  <strong className="text-white">Company info</strong><br />
                  Lloyd James is a trading name of Tele Prospects Ltd. A company registered in England & Wales, registration number 05091787.<br />
                  VAT Registration No. 835439412. ICO Number Z9386334.<br />
                </p>
              </div>
            </div>
          </div>
          <p className="copyright text-center text-gray-400 text-sm mt-8 pt-4 border-t border-pink-800">
            Copyright © 2026 Lloyd James Media Ltd.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
